import axios from 'axios'
import { applyMiddleware, compose, createStore } from 'redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import hardSet from 'redux-persist/lib/stateReconciler/hardSet'

import reducers from '../reducers/index'
import createHistory from 'history/createHashHistory'
import createSagaMiddleware from 'redux-saga'
import reduxPromise from 'redux-promise'
import reduxThunk from 'redux-thunk'
import rootSaga from '../sagas/index'
import { routerMiddleware } from 'react-router-redux'
import { LOGIN_USER, LOGOUT_USER } from 'constants/actionTypes'

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['contacts'],
  stateReconciler: hardSet
}

const persistedReducer = persistReducer(persistConfig, reducers)

const history = createHistory()
const routeMiddleware = routerMiddleware(history)
const sagaMiddleware = createSagaMiddleware()

const middlewares = [sagaMiddleware, routeMiddleware, reduxPromise, reduxThunk]

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
export default function configureStore (initialState) {
  const token = window.localStorage.getItem('token')
  const store = createStore(persistedReducer, initialState,
    composeEnhancers(applyMiddleware(...middlewares)))

  sagaMiddleware.run(rootSaga)

  // Intercept any 401 and logout user
  axios.interceptors.response.use(null, function (err) {
    console.log('Here')
    console.log(err)
    if (err.response.status === 401) {
      console.log('Here Too')
      window.localStorage.removeItem('token')
      store.dispatch({ type: LOGOUT_USER })
      history.push('/')
    }
    return Promise.reject(err)
  })

  // If we have a token consider the user to be signed in
  if (token) {
    store.dispatch({ type: LOGIN_USER })
  }

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers/index', () => {
      const nextRootReducer = require('../reducers/index')
      store.replaceReducer(nextRootReducer)
    })
  }
  return store
}
export { history }



// WEBPACK FOOTER //
// ./store/index.js